import { Grid, IconButton, Toolbar, makeStyles } from '@material-ui/core';
import { sidebarWidth } from '../sidebar';
import { useNavigatorControls } from '../navigator';
import AppBar from '@material-ui/core/AppBar';
import BrandIcon from '../../components/BrandIcon';
import MenuIcon from '@material-ui/icons/Menu';
import React, { forwardRef } from 'react';
import clsx from 'clsx';
const lightColor = 'rgba(255, 255, 255, 0.7)';
const useStyles = makeStyles(({ palette, spacing, breakpoints, transitions }) => ({
    secondaryBar: {
        zIndex: 0,
    },
    primaryBar: {
        borderBottom: '1px solid #E8ECEF',
    },
    menuButton: {
        marginLeft: -spacing(1),
        marginRight: spacing(2),
        transition: transitions.create(['margin-left', 'width', 'opacity'], {
            easing: transitions.easing.sharp,
            duration: transitions.duration.leavingScreen,
        }),
    },
    menuButtonShift: {
        marginLeft: -spacing(6.5),
        opacity: 0,
        transition: transitions.create(['margin-left', 'width', 'opacity'], {
            easing: transitions.easing.easeOut,
            duration: transitions.duration.enteringScreen,
        }),
    },
    link: {
        textDecoration: 'none',
        color: lightColor,
        '&:hover': {
            color: palette.common.white,
        },
    },
    button: {
        borderColor: lightColor,
    },
    search: {
        flexGrow: 99,
        flexBasis: 0,
        [breakpoints.up('lg')]: {
            maxWidth: `calc(100% - ${sidebarWidth}px + ${spacing(2)}px)`,
        },
    },
}));
export const Header = forwardRef((props, ref) => {
    const { navigatorState, toggleNavigator } = useNavigatorControls();
    const { config, ...rest } = props;
    const goHome = () => {
        window.location.href = config.logoUrl || window.location.origin;
    };
    const classes = useStyles();
    return (React.createElement(AppBar, Object.assign({ ref: ref, position: "sticky", elevation: 0, className: classes.primaryBar }, rest),
        React.createElement(Toolbar, { style: { height: '100%' } },
            React.createElement(Grid, { container: true, spacing: 1, alignItems: "center" },
                config.isNavigatorVisible ? (React.createElement(IconButton, { color: "inherit", "aria-label": "Open drawer", onClick: toggleNavigator, className: clsx(classes.menuButton, {
                        [classes.menuButtonShift]: navigatorState !== 'drawer-closed' && navigatorState !== 'drawer-open',
                    }) }, config.isMenuButtonShown && React.createElement(MenuIcon, null))) : (React.createElement(BrandIcon, { onClick: goHome, className: clsx(classes.menuButton) })),
                React.createElement("div", { className: classes.search }, config.searchBar),
                React.createElement(Grid, { item: true, xs: true }),
                config.headerItems && React.createElement(Grid, { item: true }, config.headerItems))),
        config.secondRowItems));
});
//# sourceMappingURL=Header.js.map